<template>
	<div>
		<div class="tableView">
			<div class="table_list">
				<span style="line-height: 32px">名称:</span>
				<el-input v-model="select.selectName" placeholder="请输入项目名称" @clear="getApplication" :clearable="true"
					style="margin-left: 10px;width: 200px;"></el-input>
			</div>

			<!--<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">项目类型:</span>
				<el-select v-model="select.selectValue1" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange1">
					<el-option v-for="(item, index) in select.options1" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>-->
			<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">状态:</span>
				<el-select v-model="select.selectValue2" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange2">
					<el-option v-for="(item, index) in select.options2" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>
			<div>
				<el-button type="primary" style="margin-left: 20px" @click="searchData">
					查询
				</el-button>
				<!--<el-button type="primary" @click="report">统一推荐</el-button>-->
			</div>
		</div>
		<!-- 表格 -->
		<normalTable :check="true" @checkbox="checkBox" v-loading="loading" :tabList="tabList" :tableList="tableList"
			@copol-click="reciveClick">
		</normalTable>

		<div style="margin-top: 50px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>

		<!-- 弹窗 -->
		<payMoney ref="paymoney"></payMoney>
		<huizong_table ref="huizong_table"></huizong_table>
		<pm_hz_table ref="pm_hz_table"></pm_hz_table>

	</div>
</template>

<script>
	import {
		getAppliInfo,
		getProjectType
	} from '../../api/moudles/application.js'


	import {

		report
	} from '../../api/moudles/management.js'

	import payMoney from './components/payMoney.vue'
	import normalTable from '../../components/table/normalTable.vue'
	import huizong_table from "./components/huizong_table";
	import pm_hz_table from "./components/pm_hz_table";
	import {deleteApply} from "../../api/moudles/management";

	export default {
		data() {
			return {
				select: {
					options1: [],
					options2: [],
					selectName: '',
					selectValue1: '',
					selectValue2: ''
				},
				tabList: ['项目名称', '申请时间', '已提交','已审核','已推荐', '状态', '动作'],
				tableList: [],
				tabCodeList: [],
				loading: false,
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0,
				ids: [],
				project_type:''
			}
		},
		components: {
			payMoney,
			normalTable,
			huizong_table,
			pm_hz_table,
		},
		created() {
			this.level()
			this.getApplication()
			this.getProjecttype()
		},
		watch: {
			'$route': function() {
				console.log('basicinfo路由切换', this.$route)

				if(this.$route.name == 'zjBasicinfo'){
					this.project_type = 10

					console.log(this.project_type)
					console.log(787878787878878788)
				}
			}
		},
		methods: {
			async reportApi(project_code) {

				const params = {
					ids: project_code
				}
				await report({
					data: params,
					success: res => {

						if (res.code === 200) {

							this.$message({
								message: res.msg,
								type: 'success'
							});

							this.dialogVisible = false

							setTimeout(() => {
								this.$router.replace('/basicinfo')
							}, 500)

						} else {
							this.$message.error(res.msg)
						}

					}
				})
			},

			report(project_code) {
				this.reportApi(project_code)

			},

			// 复选框
			checkBox(e) {
				// console.log('接收到复选框', e)
				const newList = []

				console.log(this.tabCodeList)

				e.forEach((item, index) => {
					if (item === true) {
						newList.push(this.tabCodeList[index])
					}
				})

				console.log(5675676576577657)
				console.log(e)
				console.log(7878787878787875)

				this.ids = newList
			},

			// 获取下拉选项
			async getProjecttype() {
				console.log('当前路由',this.$route)
				await getProjectType({
					data: {},
					success: res => {
						console.log(res)
						const typeAll = res.data.typeAll
						const statusAll = res.data.statusAll
						const newtypeAll = []
						const newStatusAll = []

						Object.keys(typeAll).forEach((item, index) => {
							const newList = {}
							newList.text = typeAll[item]
							newtypeAll.push(newList)
						})
						statusAll.forEach((item, index) => {
							const newList = {}
							newList.text = item
							newStatusAll.push(newList)
						})
						this.select.options1 = newtypeAll
						this.select.options2 = newStatusAll
					}
				})
			},
			selectChange1() {
				// console.log(this.select.selectValue1)
			},
			selectChange2() {
				// console.log(this.select.selectValue2)
			},
			searchData() {
				this.getApplication()
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getApplication()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getApplication()
			},
			// 二级管理员跳转
			level() {
				const level = localStorage.getItem('userLevel')
				if (level === '2') {
					// console.log('2', level)
					this.$router.replace('/infochange')
				}
			},
			async getApplication() {

				console.log(89898989898989)

				const params = {
					name: this.select.selectName,
					status: this.select.selectValue2,
					page: this.currentPage,
					limit: this.pageSize,
					project_type:10
				}
				this.loading = true
				await getAppliInfo({
					data: params,
					success: (res) => {
						// console.log('获取信息', res)
						this.totalNum = res.totalCount
						let dataList = res.data;
						let upCode = []
						let upList = []
						dataList.forEach((item) => {
							let newlist = {}
							//newlist['project_type_name'] = item.project_type_name
							newlist['project_name'] = item.project_name
							newlist['apply_time'] = item.apply_time

							//newlist['distribution_count'] = item.enp.distribution_count
							newlist['collect_count'] = item.enp.collect_count
							newlist['app_count'] = item.enp.app_count
							newlist['recd_count'] = item.enp.recd_count
							newlist['status_name'] = item.enp.status_name
							if (item.recommender == 1) {

								if(item.enp.status_name =='已结束'){
									newlist['soqcol'] = ['下载推荐汇总表','查看明细']
								}else{
									newlist['soqcol'] = ['下载推荐汇总表','查看明细','统一推荐']
								}

							} else {
								newlist['soqcol'] = ['二级管理员']
							}

							upCode.push(item.project_code)
							upList.push(newlist)
						})
						this.tabCodeList = upCode
						this.tableList = upList
						this.loading = false
					}
				})
			},
			// 弹窗
			payMoney() {
				this.$refs['paymoney'].showPay()
			},
			showCopol(key) {
				console.log('key', key)
				this.payMoney()
			},
			// 接受子组件事件
			reciveClick(e) {
				console.log('e', e)

				if (e.list == '下载推荐汇总表') {

					if(e.item.project_name.indexOf("项目经理") != -1 ){

						const {
							key
						} = e
						this.$refs['pm_hz_table'].showPay(this.tabCodeList[key])
					}else{
						const {
							key
						} = e
						this.$refs['huizong_table'].showPay(this.tabCodeList[key])
					}


				}else if(e.list == '查看明细'){

					if(e.item.project_name.indexOf("项目经理") != -1 ){
						this.$router.push('/contribute')
					}else if(e.item.project_name.indexOf("QC小组") != -1){
						this.$router.push('/qcContribute')
					}

				} else if(e.list == '统一推荐'){

					const {
						key
					} = e

					let that = this
					this.$confirm('请确保审核完成，统一推荐后申报单位不允许提交，确定推荐吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						center: true
					}).then(() => {
						that.report(this.tabCodeList[key])
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});


				}else {
					const {
						key
					} = e
					this.$refs['paymoney'].showPay(this.tabCodeList[key])
				}

			}
		}
	}
</script>

<style scoped="scoped">
	.tableView {
		display: flex;
		margin: 20px 0;
		flex-wrap: wrap;
	}

	.table_list {
		margin-bottom: 10px;
	}
	.innerTable > p{
		margin-right: 10px !important;
	}
</style>
